import { FC, useEffect, useMemo } from 'react';
import { SagittalSpineMetrics } from '../../types/sagittalTypes';
import { createPerpendicularLine } from '../../components/ScanItemViewer/MeshViewer/MeshLoadingHelpers';
import { MetricKeyEnum, useLayerStore } from '../LayerControls/layerStore';
import { ThreeDLabel } from '../3dModels/ThreeDLabel';
import { useHighlighter } from '../ui/useHighlighter';

interface SagittalMetricProps {
  sagittalSpineMetrics: SagittalSpineMetrics;
  layerKey: MetricKeyEnum.MaxLowerSagittal | MetricKeyEnum.MaxUpperSagittal;
}

export const SagittalMetric: FC<SagittalMetricProps> = ({
  sagittalSpineMetrics,
  layerKey,
}) => {
  const { addLayerState, isLayerVisible } = useLayerStore();
  useHighlighter({ layerKey });

  const { group: lowerPerpLine, labelPosition } = useMemo(() => {
    return createPerpendicularLine(sagittalSpineMetrics, 0.005, 'blue');
  }, [sagittalSpineMetrics]);

  const angle = sagittalSpineMetrics.angle;

  useEffect(() => {
    if (lowerPerpLine === null) {
      return;
    }
    addLayerState(layerKey, {
      key: layerKey,
      visible: false,
    });
  }, [addLayerState, layerKey, lowerPerpLine]);

  const showLayer = isLayerVisible(layerKey);

  if (lowerPerpLine === null) {
    return null;
  }

  return (
    <group name={layerKey} visible={showLayer}>
      <mesh>
        <primitive object={lowerPerpLine} />
        <ThreeDLabel
          plane='sagittal'
          position={labelPosition.toArray()}
          label={`${angle.toFixed(2)}°`}
          visible={showLayer}
          divPosition={{
            top: -16,
            left: 8,
          }}
          layerKey={layerKey}
        />
      </mesh>
    </group>
  );
};
